import * as http from '../apiClient';
import type { HttpRequestConfig, HttpResponseInterface } from '../httpClient';

const listeners = new Set<() => void>();
export const subscribeStorageChanges = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// All cloudsave writes pass here; only successful writes invalidate projects.
// Leases change editing locks, not project-list contents.
const mutation =
  (send: typeof http.post) =>
  async <T>(
    path: string,
    body?: string,
    config?: HttpRequestConfig,
    baseUrl?: string,
  ): Promise<HttpResponseInterface<T>> => {
    const response = await send<T>(path, body, config, baseUrl);
    if (!path.endsWith('/lease')) for (const listener of listeners) listener();
    return response;
  };
export const post = mutation(http.post);
export const put = mutation(http.put);
export const remove = mutation(http.remove);
